import React, { Component } from "react";
import { Status_BG_Data } from "../../../constants/internal-constants.js";
import { TableIcon } from "../table-icon/table-icon.compoent";
import Icons from "../../icon";
import { PaginationExhibit1 as Pagination } from "../../common/table/pagination.component";
import moment from "moment";
import { findObjVal } from '../../../utils/helpers.utils'
import { Button } from "react-bootstrap";

export class InternalDataTable extends Component {
    constructor(props) {
        super(props);
        this.getDataOnTable=this.getDataOnTable.bind(this)
    }
    getDataOnTable(event) {   
        this.props.getData(true);
       
    }

    handleDeleteClick(event) {
        event.stopPropagation();
        alert("No code yet")
    }

    render() {
        const { dataTable, dataHeader, pages } = this.props;

        const orderList = () => {
           
            return (
                <tbody>
                    {dataTable.map((item, id) => {
                       
                        return (
                            <tr key={id} onClick={this.getDataOnTable}>
                                <td className={`status-fill`}>
                                    <span className={`cicle-tr-curr  ${Status_BG_Data[item.Status] || ''}`}></span>
                                </td>
                                <td>
                                    {item.OrderNumber}
                                </td>
                                <td>
                                    {item.RequestType}
                                </td>
                                <td>
                                    {item.Requestor}
                                </td>
                                <td>
                                    {item.AssignedTo}
                                </td>
                                <td>
                                    {item.VendorName}
                                </td>
                                <td>
                                    {item.LastUpdated}
                                </td>
                                <td>
                                    {item.SubmittedDate}
                                </td>
                                <td>
                                    {item.RequestDate}
                                </td>
                                <td>
                                    {item.ApprovedDate}
                                </td>
                                <td>
                                    {item.Country} 
                                </td>
                                <td onClick={this.handleDeleteClick}>
                                    <TableIcon  IconName="trash-can" IconSize="12px" />
                                </td>
                            </tr>
                        )
                    }
                    )}
                </tbody>
            )
        }

        
        const invoiceList = () => {
          
            return (
                <tbody>
                    {dataTable.map((item, id) => {
                       
                        return (
                            <tr key={id}>
                                <td className="status-fill">
                                    <span className={`cicle-tr-curr ${Status_BG_Data[item.Status] || ''}`} ></span>
                                </td>
                                <td onClick={this.getDataOnTable}>
                                    {item.VendorName}
                                </td>
                                <td onClick={this.getDataOnTable}>
                                    {item.AccountNumber}
                                </td>
                                <td onClick={this.getDataOnTable}>
                                    {item.SubAcct_Number}
                                </td>
                                <td onClick={this.getDataOnTable}>
                                    {item.InvoiceDate}
                                </td>
                                <td onClick={this.getDataOnTable}>
                                    {item.InvoiceNum}
                                </td>
                                <td onClick={this.getDataOnTable}>
                                    {item.Currency}
                                </td>
                                <td onClick={this.getDataOnTable}>
                                    {item.AssignedTo}
                                </td>
                                <td onClick={this.getDataOnTable}>
                                    {item.Net}
                                </td>
                                <td onClick={this.getDataOnTable}>
                                    {item.Tax}
                                </td>
                                <td onClick={this.getDataOnTable}>
                                    {item.DateUploaded}
                                </td>
                                <td>
                                    {item.ApprovedDate}
                                </td>
                                <td>
                                    {item.Country}
                                    <TableIcon IconName="trash-can" IconSize="12px" />
                                </td>
                            </tr>
                        )
                    }

                    )}
                </tbody>
            )
        }


        return (
            <div className="table-container-wrapper">
                <table className="table">
                    <thead>
                        <tr>
                            {dataHeader.map((item, id) =>
                            (
                                <th key={id}>
                                    {item !== "" ?
                                        <div className="header-content">{item}
                                            <Icons
                                                name="sort-down-solid"
                                                size="14px"
                                                customClassName="icon-table-header"
                                            />
                                        </div> : ""}
                                </th>
                            )
                            )}
                        </tr>
                    </thead>
                    {this.props.page === "order" ? orderList() : invoiceList()}
                </table>
                <div className="internal-pagination-container">
                  <Button className="table-view-more" > View More </Button> 
                </div>
            </div>
        )
    }
}

const getDataOnTable=()=> {   
    this.props.getData(true);
   
}

export class InternalDataTableGrid extends Component {
    constructor(props) {
        super(props);
        this.getDataOnTable=this.getDataOnTable.bind(this)
    }

    getDataOnTable() {   
        this.props.getData(true);
       
    }
    
    render() {
        const { dataTable, pages } = this.props;
        const orderGrid = () => {           
            return (
                <div className="order-container grid-view">
                    {dataTable.map((v, i) => {
                      
                        return (
                            <div key={i} className="div-order">
                                <div className="tile-order-header">
                                    <div className="tile-order-data">
                                        <p className="tile-order-type">Order Request: {v.OrderType}</p>
                                        <p className="tile-order-id"> {v.OrderNumber} </p>
                                    </div>
                                    <span className={`cicle-tr-curr ${Status_BG_Data[v.Status] || ''}`}></span>
                                </div>
                                <div className="div-separator"></div>
                                <div className="tile-order-info">
                                    <span className="order-id-data">
                                        <p className="info-label">Order ID: </p>
                                        <p className="info-value">{v.OrderID}</p>
                                    </span>
                                    <span className="requestor-data">
                                        <p className="info-label">Requestor: </p>
                                        <p className="info-value">{v.Requestor}</p>
                                    </span>
                                    <span className="circuit-id-data">
                                        <p className="info-label">Circuit ID: </p>
                                        <p className="info-value">{v.CircuitCode}</p>
                                    </span>
                                    <span className="request-date-data">
                                        <p className="info-label">Request Date: </p>
                                        <p className="info-value"> {v.RequestDate}</p>
                                    </span>
                                    <span className="assigned-to-data">
                                        <p className="info-label">Assigned To: </p>
                                        <p className="info-value assignedTo"> {v.AssignedTo} </p>
                                    </span>
                                </div>
                            </div>
                        )
                    })}
                </div>
            )
        }

        const invoiceGrid = () => {
          
            return (
                <div className="order-container grid-view">
                    {dataTable.map((v, i) => {                      
                        return (
                            <div key={i} className="div-order">
                                <div className="tile-order-header">
                                    <div className="tile-order-data">
                                        <p className="tile-order-type">Invoice Number</p>
                                        <p className="tile-order-id"> {v.InvoiceNum} </p>
                                    </div>
                                    <div className="status-cont">
                                        <span className={`cicle-tr-curr ${Status_BG_Data[v.Status] || ''}`}></span>
                                        <Icons name="trash-can" size="16px" onClick={()=>alert("Code Here")}/>
                                    </div>
                                </div>
                                <div className="div-separator"></div>
                                <div className="tile-order-info" onClick={this.getDataOnTable}>
                                    <span className="order-id-data">
                                        <p className="info-label">Account No: </p>
                                        <p className="info-value">{v.AccountNumber}</p>
                                    </span>
                                    <span className="requestor-data">
                                        <p className="info-label">Sub Account No: </p>
                                        <p className="info-value">{v.SubAcct_Number}</p>
                                    </span>
                                    <span className="circuit-id-data">
                                        <p className="info-label">Vendor: </p>
                                        <p className="info-value">{v.VendorName}</p>
                                    </span>
                                    <span className="request-date-data">
                                        <p className="info-label">Invoice Date: </p>
                                        <p className="info-value"> {moment(v.InvoiceDate).format("DD/MM/YYYY")}</p>
                                    </span>
                                    <span className="assigned-to-data">
                                        <p className="info-label">Assigned To: </p>
                                        <p className="info-value assignedTo"> {v.AssignedTo} </p>
                                    </span>
                                </div>
                            </div>
                        )
                    })}
                </div>
            )
        }

        return (
            <div className="table-container-wrapper">
                <div className="order-cont-wrapper">
                    {this.props.page === "order" ? orderGrid() : invoiceGrid()}
                    <div className="internal-pagination-container">
                        <Button className="table-view-more" > View More </Button> 
                    </div>
                </div>
            </div>
        )
    }

}